import * as React from 'react';
import { DefaultProjectDataProvider } from './DefaultProjectDataProvider';
import { ProjectDataProvider } from './ProjectDataProvider';

const Context = React.createContext<ProjectDataProvider>(DefaultProjectDataProvider);

export interface PluginDataProviderContextProviderProps {
	children: React.ReactNode;
	dataProvider?: ProjectDataProvider;
}

export function PluginDataProviderContextProvider(
	props: PluginDataProviderContextProviderProps
) {
	return (
		<Context.Provider value={props.dataProvider ?? DefaultProjectDataProvider}>
			{props.children}
		</Context.Provider>
	);
}

export const usePluginDataProviderContext = () => React.useContext(Context);
